<template>
  <footer class="bg-neutral-100 py-6">
    <div class="container-app text-center">
      <p class="text-neutral-500 text-sm">
        &copy; 2026 by RECC.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter'
};
</script>
